import React from "react";
import * as CPL from "@teamsparta/cross-platform-logger";
import { config } from "../../../src/config";

CPL.initCPLog(
    config.flounder.cognitoKey,
    config.amplitude.key,
    config.hackle.key,
    !config.production
);

const throttlePool = {};
/**
 * eventID 항목은 유명무실하기 때문에 빈 문자열만 넣어도 괜찮습니다.
 * TODO: 빈 문자열도 안넣어도 되도록 감싸야함.*/
export const sendCPLog = async (
    action,
    data,
) => {
    if (!throttlePool[action]) {
        throttlePool[action] = true;

        CPL.sendCPLog(action, data);

        setTimeout(() => {
            throttlePool[action] = false;
        }, 100);
    } else {
        console.error("duplicate send log");
    }
};


